
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="vp-sub-folder-dialog mail-dialog">
    <div *ngIf="!showSearch" id="mobile_sidebar_folder_header" class="mail__dialog-header disable-select"
        layout="row center-center">
        <div>
            <button (click)="getParentFolder()" id="mobile_sidebar_folder_backbtn"
                class="brand-color mat-button disable-select">
                <mat-icon class="disable-select">chevron_left</mat-icon>
            </button>
        </div>
        <div class="header-title disable-select">
            <span class="disable-select" *ngIf="selectedMailFolder">{{ getFolderNameKey(selectedMailFolder.name,
                MailConstants?.SYSTEM_FOLDERS) }}</span>
            <span class="disable-select" *ngIf="!selectedMailFolder">{{ 'FOLDERS' | translate}}</span>
        </div>
        <div class="mobile-right-close disable-select">
            <button class="brand-color mat-button" (click)="close()" id="mobile_sidebar_folder_closebtn">
                <mat-icon class="disable-select">close</mat-icon>
            </button>

            <button class="brand-color mat-button" (click)="showSearchForm()" id="mobile_sidebar_folder_searchbtn">
                <mat-icon class="disable-select">search</mat-icon>
            </button>
        </div>
    </div>
    <div *ngIf="showSearch" id="mobile_sidebar_folder_header" class="search-folder-form mail__dialog-header search-form"
        layout="row center-center">
        <div>
            <button (click)="showSearch = false" id="mobile_sidebar_folder_backbtn"
                class="brand-color mat-button disable-select">
                <mat-icon class="disable-select">chevron_left</mat-icon>
            </button>
        </div>
        <div class="header-title search-form">
            <input autofocus matInput #folderSearchInput [(ngModel)]="searchText" type="text" id="folder-search-input"
                placeholder="{{'SEARCH' | translate}}" />
        </div>
        <div class="disable-select">
            <button class="brand-color mat-button" (click)="searchText = ''" id="mobile_sidebar_folder_closebtn">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="mail__dialog-body mail__dialog-body--pad disable-select" (scroll)="onUserScroll($event)">
        <ng-container *ngIf="!searchText">
            <mat-tree [dataSource]="folderDataSource" [treeControl]="folderTreeControl" class="mobile-folder-tree">
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren">
                    <div class="folder-row" vpLongPress [timeout]="500" (click)="routeToFolder(node)"
                        (onLongPress)="$event.stopPropagation(); openActionList(node)">

                        <button mat-icon-button matTreeNodeToggle class="expander-button">
                            <mat-icon>
                                {{ folderTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>

                        <div class="folder-icon-wrapper">
                            <mat-icon *ngIf="node.icon" [style.color]="node.rgb || '#808080'">
                                {{ node.icon }}
                                </mat-icon>
                                <div *ngIf="!node.icon">
                                <ng-container [ngTemplateOutlet]="folderIcon"
                                    [ngTemplateOutletContext]="{ color: node.rgb || '#808080' }"></ng-container>
                                </div>
                            <span class="mail-count"
                                *ngIf="node.name !== 'Drafts' && node.u && node.u !== '0' && node.u !== 0">
                                {{ node.u > 99 ? '99+' : node.u }}
                            </span>
                        </div>
                        <span class="folder-label" [ngClass]="{'broken-share-folder': node.owner && !node.oname}">
                            {{ getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS) }}
                        </span>
                    </div>
                    <ng-container *ngIf="folderTreeControl.isExpanded(node)">
                        <div class="child-node-container">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </ng-container>
                </mat-nested-tree-node>
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    <div class="folder-row" (click)="routeToFolder(node)" vpLongPress [timeout]="500"
                        (onLongPress)="$event.stopPropagation(); openActionList(node)">
                        <button mat-icon-button disabled class="expander-button"></button>

                        <div class="folder-icon-wrapper">
                        <mat-icon *ngIf="node.icon" [style.color]="node.rgb || '#808080'">
                        {{ node.icon }}
                        </mat-icon>
                        <div *ngIf="!node.icon">
                        <ng-container [ngTemplateOutlet]="folderIcon"
                            [ngTemplateOutletContext]="{ color: node.rgb || '#808080' }"></ng-container>
                        </div>
                            <span class="mail-count"
                                *ngIf="node.name !== 'Drafts' && node.u && node.u !== '0' && node.u !== 0">
                                {{ node.u > 99 ? '99+' : node.u }}
                            </span>
                        </div>
                    <span class="folder-label" [ngClass]="{'broken-share-folder': node.owner && !node.oname}">
                         {{ (node?.name | lowercase) === 'starred' ? ('FAVOURITES' | translate) : getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS) }}
                     </span>
                    </div>
                </mat-tree-node>

            </mat-tree>
        </ng-container>
        <ng-container *ngIf="searchText">
            <div *ngIf="selectedMailFolder?.children?.length">
                <mat-list>
                    <mat-list-item *ngFor="let folder of selectedMailFolder.children | vpFolderNameSearch: searchText">
                        <div class="folder-row" (click)="routeToFolder(folder)">
                            <div class="folder-icon-wrapper">
                                <ng-container [ngTemplateOutlet]="folderIcon"
                                    [ngTemplateOutletContext]="{ color: folder.rgb }"></ng-container>
                                <span class="mail-count"
                                    *ngIf="folder.name !== 'Drafts' && folder.u && folder.u !== '0' && folder.u !== 0">
                                    {{ folder.u > 99 ? '99+' : folder.u }}
                                </span>
                            </div>
                            <span>{{ getFolderNameKey(folder.name, MailConstants?.SYSTEM_FOLDERS) }}</span>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>

            <div *ngIf="!selectedMailFolder && rootUserFolders">
                <mat-list>
                    <mat-list-item *ngFor="let folder of rootUserFolders | vpFolderNameSearch: searchText">
                        <div class="folder-row" (click)="routeToFolder(folder)">
                            <div class="folder-icon-wrapper">
                                <ng-container [ngTemplateOutlet]="folderIcon"
                                    [ngTemplateOutletContext]="{ color: folder.rgb }"></ng-container>
                                <span class="mail-count"
                                    *ngIf="folder.name !== 'Drafts' && folder.u && folder.u !== '0' && folder.u !== 0">
                                    {{ folder.u > 99 ? '99+' : folder.u }}
                                </span>
                            </div>
                            <span>{{ getFolderNameKey(folder.name, MailConstants?.SYSTEM_FOLDERS) }}</span>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
        </ng-container>
    </div>
</div>
<vp-mail-operation-button (click)="createNewFolder(selectedMailFolder)" [iconType]="globalOperationIcon">
</vp-mail-operation-button>

<ng-template #folderIcon let-color="color">
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/folder-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(2.000000, 4.000000)">
              <path d="M7.00922203,0 C7.49995184,0 8.18025928,0.262988878 8.59481703,0.605726148 L8.71075654,0.71075654 L9.28924346,1.28924346 C9.65129486,1.65129486 10.3113868,1.94247309 10.8421188,1.99242242 L10.9970301,2 L18,2 C19.05,2 19.9177686,2.82004132 19.9944872,3.85130541 L20,4 L20,14 C20,15.05 19.1799587,15.9177686 18.1486946,15.9944872 L18,16 L2,16 C0.95,16 0.082231405,15.1799587 0.00551277235,14.1486946 L0,14 L0.01,2 C0.01,0.95 0.820929752,0.082231405 1.85136551,0.00551277235 L2,0 L7.00922203,0 Z M7.00922203,2 L2.00999931,2.00166667 L2,14 L18,14 L18,4 L10.9970301,4 C9.98506984,4 8.81419501,3.54226902 8.03565409,2.85431634 L7.8750299,2.70345702 L7.29654298,2.1249701 L7.27022108,2.10994272 L7.0847011,2.02870664 L7.00922203,2 Z" id="Shape"
              [attr.fill]="color"></path>
          </g>
      </g>
  </svg>
</ng-template>